<template>
  <Table
    ref="table"
    :statuses-items="failuresItems"
    :layers-filters="layersFilters"
    @setLayerFeaturesFilters="setLayerFeaturesFilters"
    @deleteLayerFeaturesFilters="deleteLayerFeaturesFilters"
    :is-custom-layer="true"
    :custom-layer-data="customLayerData"
  >
    <template v-slot:additionalTools="scope">
      <v-col style="flex-grow: 0" v-for="(select, idx) of selects" :key="idx">
        <table-select v-model="scope.filters.navbar_filter[select.name]" v-bind="select" @input="changeFilters()" />
      </v-col>
    </template>
  </Table>
</template>

<script>
import { get, sync } from 'vuex-pathify';

import Table from '@/components/Table.vue';
import TableSelect from '@/components/TableSelect.vue';

export default {
  name: 'TableFailures',
  components: {
    Table,
    TableSelect,
  },
  computed: {
    activeTool: sync('tools/activeTool'),
    currentLayerDataSourceName: sync('layers/currentLayer@data_source_name'),
    failuresStatuses: get('admin/modulesMapping@failures.statuses'),
    failuresLayerId: get('admin/modulesMapping@failures.layer_id'),
    layersFilters: get('layers/layersFilters'),
    users: get('users/users'),
    usersArray() {
      return this.$_objectToArray(this.users);
    },
    customLayerData() {
      return {
        routeName: 'failure',
        eventName: 'toggleFailures',
        filterEventName: 'toggleFailuresFilter',
        layerId: this.failuresLayerId,
      };
    },
  },
  data: vm => ({
    filtersValues: {
      status: '',
      assigned_user: '',
      reported_by: '',
    },
    selects: [
      {
        name: 'status',
        itemText: 'value',
        label: vm.$i18n.t('dialog.status'),
        items: [],
      },
      {
        name: 'assigned_user',
        itemText: 'name',
        itemValue: 'id',
        label: vm.$i18n.t('dialog.assignedPerson'),
        items: [],
      },
      {
        name: 'reported_by',
        itemText: 'name',
        itemValue: 'id',
        label: vm.$i18n.t('dialog.reportingPerson'),
        items: [],
      },
    ],
    failuresItems: [
      {
        key: 'new',
        color: 'rgba(191,54,12)',
        shadowColor: 'rgba(191,54,12,0.2)',
      },
      {
        key: 'completed',
        color: 'rgba(24,128,56)',
        shadowColor: 'rgba(24,128,56,0.2)',
      },
      {
        key: 'active',
        color: 'rgba(255,136,0)',
        shadowColor: 'rgba(255,136,0,0.2)',
      },
      {
        key: 'planned',
        color: 'rgba(108,108,108)',
        shadowColor: 'rgba(108,108,108,0.2)',
      },
      {
        key: 'unrealized',
        color: 'rgba(191,54,12)',
        shadowColor: 'rgba(191,54,12,0.2)',
      },
    ],
  }),
  methods: {
    changeFilters() {
      this.$refs.table.handleFilter();
    },
    deleteLayerFeaturesFilters(currentLayerId) {
      this.$store.set('layers/DELETE_LAYERS_FILTERS!', currentLayerId);
    },
    onLayerChanged() {
      this.$refs.table.onLayerChanged();
    },
    setLayerFeaturesFilters(filter) {
      this.$store.set('layers/SET_LAYERS_FILTERS!', filter);
    },
    setFilters(additionalTableFilterValues, isInit) {
      setTimeout(() => {
        this.$refs.table.setNavbarFilters(additionalTableFilterValues, isInit);
      });
    },
  },
  beforeCreate() {
    this.$once('hook:beforeDestroy', () => {
      this.$nextTick(() => {
        this.activeTool = undefined;
      });
      this.$root.$emit('toggleFailures', false);
    });
  },
  created() {
    this.$root.$off('setAdditionalTableFilterValues');
    this.$root.$on('setAdditionalTableFilterValues', this.setFilters);
  },
  beforeMount() {
    this.selects.find(select => select.name === 'status').items = this.failuresItems.map(item => {
      item.value = this.failuresStatuses[item.key];
      return item;
    });
    this.selects.find(select => select.name === 'assigned_user').items = this.usersArray;
    this.selects.find(select => select.name === 'reported_by').items = this.usersArray;
  },
  mounted() {
    const additionalTableFilterValues = this.$route.params.additionalTableFilterValues;
    if (additionalTableFilterValues) {
      this.setFilters(additionalTableFilterValues, true);
    }
  },
};
</script>
